/* eslint-disable no-undef */

import { configureStore as createReduxStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';

import rootReducer from './reducers/index';

export default function configureStore(initialState, history) {
  const middleware = __BROWSER__ ? [routerMiddleware(history)] : [];

  return createReduxStore({
    reducer: rootReducer(history),
    preloadedState: initialState,
    // thunk and immutable-state checks are included by default; the serializable
    // check is left off to match the prior store's behavior.
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    devTools: __DEV__,
  });
}
